import { getActiveFilterCount } from 'Components/VehicleList/VehicleListV2/FilterBarV2/FilterBarV2.helpers';
import { useFilters } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';

export const useHasFilters = () => {
	const filters = useFilters();
	const activeFilterCount = getActiveFilterCount(filters);
	return activeFilterCount > 0;
};
